export default function (text, type = 'error') {
    window.dispatchEvent(new CustomEvent('notify', {
        detail: {
            type: type,
            text: text
        }
    }));
}